export default "__VITE_ASSET__oatkDZM7__"